export const searchText = (searchText, accessToken, searchCriteria) => {
  return _fetchMapbox(encodeURIComponent(searchText), _getGeocodingRequestQueryParams(accessToken, searchCriteria));
};

export const searchByGeo = (lat, lng, accessToken, searchCriteria) => {
  return _fetchMapbox(encodeURIComponent(lng) + ',' + encodeURIComponent(lat), _getForwardGeocodingRequestQueryParams(accessToken, searchCriteria));
};

export const getAddressName = mapBoxData => {
  let address;
  if (mapBoxData && mapBoxData.features && mapBoxData.features.length > 0) {
    address = mapBoxData.features[0].place_name;
  }
  return address;
};

const _fetchMapbox = (file, queryString) => {
  const url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + file + '.json?' + queryString;
  return fetch(url).then(res => {
    if (res.ok) {
      return res.json();
    } else {
      const error: any = new Error('Unable to get geo location information from mapbox ' + res.status);
      error.response = res;
      throw error;
    }
  });
};

const _getForwardGeocodingRequestQueryParams = (accessToken, searchCriteria) => {
  const { country, types, limit } = searchCriteria;
  const searchParams = _getBaseQueryParams(accessToken, country, types);
  if (limit) searchParams.set('limit', limit);
  return searchParams.toString();
};

const _getGeocodingRequestQueryParams = (accessToken, searchCriteria) => {
  const { country, types, proximity } = searchCriteria;
  const searchParams = _getBaseQueryParams(accessToken, country, types);
  if (proximity) searchParams.set('proximity', proximity);
  return searchParams.toString();
};

const _getBaseQueryParams = (accessToken, country, types) => {
  const searchParams = new URLSearchParams();
  if (!accessToken) {
    throw 'Mapbox access token is null. Can not perform geolocation search without the access token';
  }
  searchParams.set('access_token', accessToken);
  if (country) searchParams.set('country', country);
  if (types) searchParams.set('types', types);
  return searchParams;
};
